<div [formGroup]="licenseForm" fxLayout="column" fxLayoutGap="15px">
  <div *ngIf="licenseObject" fxLayout="row" fxLayoutGap="15px" class="button-container">
    <button tabindex="-1"
            (click)="save()"
            [class.spinner]="processingRequest"
            [disabled]="!licenseForm.valid || processingRequest"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz </span>
    </button>
    <button tabindex="-1" (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span>
    </button>
  </div>

  <mat-card>
    <h3>Dane</h3>

    <div fxLayout="column" fxLayoutGap="15px">
      <div fxLayout="row" fxLayoutGap="15px">
        <app-dynamic-dict fxFlex="100" label="Rodzaj licencji"
                          [required]="true" [control]="typeOfLicenseControl"
                          [dictType]="DYNAMIC_DICTIONARY_LICENSE_TYPE">
        </app-dynamic-dict>

        <mat-form-field fxFlex="50">
          <mat-label>Numer licencji</mat-label>
          <input type="text"
                 matInput
                 [formControl]="licenseNumberControl">
          <mat-error *ngIf="licenseNumberControl.hasError('required')">To pole jest wymagane</mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <app-dict-user-devices
          fxFlex="50"
          label="Urządzenie"
          [control]="deviceControl"
          [filterUser]="selectedUser || userObject"
        ></app-dict-user-devices>

        <app-datepicker
          fxFlex="50"
          label="Data ważności do"
          placeholder="2000-01-01 00:00"
          [required]="false"
          [control]="expirationDateControl"
        ></app-datepicker>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <mat-form-field fxFlex="50">
          <mat-label>Notatka</mat-label>
          <input type="text" matInput [formControl]="noteControl">
        </mat-form-field>

        <app-dict-users fxFlex="50" label="Użytkownik"
        [required]="true"
        [control]="userControl"
        [multiple]="false"
        [filterEmployeeOnly]="true"
        [filterActiveOnly]="true">
          ></app-dict-users>
      </div>

    </div>
  </mat-card>

  <div fxLayout="row" fxLayoutGap="15px">
    <button tabindex="-1"
            (click)="save()"
            [class.spinner]="processingRequest"
            [disabled]="!licenseForm.valid || processingRequest"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz </span>
    </button>
    <button tabindex="-1" (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span>
    </button>

  </div>

</div>
